import b from 'b_';
import cx from 'classnames';
import { Count } from 'education-icons';
import React from 'react';

import { HELP_TYPE } from '../../constants';
import Help from '../../help/help';
import Text from '../../text/text';
import Tooltip from '../../tooltip/tooltip';
import { BLOCK_CARDS_COUNT, WARNING_CARDS_COUNT } from '../constants';

import { TYPES } from './typings';
import { getDisplayType } from './utils';

import './lesson-meta__cards-count.scss';

interface CardsCountProps {
    cardsCount: number;
    children?: React.ReactNode | Array<React.ReactNode>;
    mix?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tooltipProps?: Record<string, any>;
    showIcon?: boolean;
    shouldShowWarning?: boolean;
}

// eslint-disable-next-line @typescript-eslint/ban-types
class CardsCount extends React.PureComponent<CardsCountProps, {}> {
    static defaultProps = {
        showIcon: false,
        shouldShowWarning: false,
    };

    getIcon = (type: TYPES): React.ReactNode => {
        const { tooltipProps, shouldShowWarning } = this.props;

        if (!shouldShowWarning) {
            return null;
        }

        switch (type) {
            case TYPES.DEFAULT:
                return null;
            case TYPES.WARNING:
                return (
                    <Help
                        mix="cards-count__help"
                        popupProps={tooltipProps}
                        tooltipTheme={Tooltip.THEME.WARNING}
                        type={HELP_TYPE.WARNING}
                    >
                        <Text id="cardsCount.warning" values={{ cardsWarning: WARNING_CARDS_COUNT }} />
                    </Help>
                );
            case TYPES.BLOCK:
                return (
                    <Help
                        mix="cards-count__help"
                        popupProps={tooltipProps}
                        tooltipTheme={Tooltip.THEME.ERROR}
                        type={HELP_TYPE.ERROR}
                    >
                        <Text id="cardsCount.block" values={{ cardsBlock: BLOCK_CARDS_COUNT }} />
                    </Help>
                );
            default:
                return null;
        }
    };

    render() {
        const { cardsCount, children, mix, shouldShowWarning, showIcon } = this.props;

        const type = getDisplayType(cardsCount, shouldShowWarning);

        return (
            <div className={cx(mix, b('cards-count', { type }))}>
                {showIcon && <Count className="cards-count__icon" />}
                {children || <Text id="cardsCount" values={{ cardsCount }} />}
                {this.getIcon(type)}
            </div>
        );
    }
}

export default CardsCount;
